// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"ce7afd63","597":"c3409af4","3666":"ce5523bc"}[chunkId] + ".chunk.css";
};